const setSuggestionStatus = (state, action, status) => {
  if (action.meta.arg.fileId) {
    if (!state.suggestionStatus[action.meta.arg.nodeId]) {
      state.suggestionStatus[action.meta.arg.nodeId] = {};
    }
    state.suggestionStatus[action.meta.arg.nodeId][action.meta.arg.fileId] = status;
  } else {
    state.suggestionStatus[action?.meta?.arg.nodeId] = status;
  }
}

const handleAIResponse = (state, action, formattedText) => {
  const node = state.nodesById[action.meta.arg.nodeId];

  if (action.meta.arg.fileId) {
    // nodeId is parent (input-images, input-files), we don't have independent nodeIds for every images/files
    if (!state.acceptedSuggestion[action.meta.arg.nodeId]) {
      state.acceptedSuggestion[action.meta.arg.nodeId] = {};
    }
    if (!state.suggestionHistory[action.meta.arg.nodeId]) {
      state.suggestionHistory[action.meta.arg.nodeId] = {};
    }

    if (action.meta.arg.text) {
      state.suggestionHistory[action.meta.arg.nodeId][action.meta.arg.fileId] = {text: action.meta.arg.text, aiUsed: action.meta.arg.aiUsed};
    }

    state.acceptedSuggestion[action.meta.arg.nodeId][action.meta.arg.fileId] = {text: formattedText, format: action.meta.arg.format};
  } else {
    const originalText = node?.value?.text || node?.text || node?.title;
    state.suggestionHistory[action.meta.arg.nodeId] = {text: originalText, aiUsed: node.ai_used};
    state.acceptedSuggestion[action.meta.arg.nodeId] = {text: formattedText, format: action.meta.arg.format, aiUsed: true};
  }
}

export const aiHelpers = {
  setSuggestionStatus,
  handleAIResponse
};